import { exportFetch } from './ActionUtils'
import ApplicationConf from 'conf/ApplicationConf'
import download from 'downloadjs'
import { getDateExport } from './DateUtil'
import { toast } from 'react-toastify'

const ExportAction = {
    exportData: (dataFormatted, titleFile, type='xlsx') => {
        return exportFetch(ApplicationConf.aqua6Bo.export(), { body: { data: dataFormatted, type }, method: 'POST' })
            .then((resp) => {
                return resp.blob()
            }).then((blob) => {
                download(blob, `${titleFile}_${getDateExport()}.${type}`, blob.type)
            })
            .catch((e) => {
                toast.error('Erreur lors de l\'export des données')
                // eslint-disable-next-line no-console
                console.error('Export error', e)
            })
    },
}
export { ExportAction }